import React from 'react';
import { Switch, Route, Redirect } from 'react-router';
import { RouterSettings } from 'constants/models/routerSettings';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';

const renderRoutes = (routes, extraProps = {}, switchProps = {}) => {
  return routes ? (
    <Switch {...switchProps}>
      {routes.map((route, i) => (
        <Route
          key={route.key || i}
          path={route.path}
          exact={route.exact}
          strict={route.strict}
          render={props => {
            let renderRes;
            renderRes = route.render
              ? route.render({ ...props, ...extraProps, route: route })
              : <route.component {...props} {...extraProps} route={route} />;

            if (!validLogin(route.login, props.location)) {
              // console.log('路由 location', props.location);
              // console.log('需登入 route', route);
              storageService.clearAll.all();

              const path = {
                pathname: RouterSettings.Login,
                state: { preUrl: props.location.pathname, originUrl: props.location.pathname }
              };

              renderRes = <Redirect to={path} />;
            }

            return renderRes;
          }}
        />
      ))}
    </Switch>
  ) : null;
};

/**
 * @description 判斷該路由是否需登入
 * @param {Boolean} needLogin
*/
const validLogin = (needLogin, location) => {
  // 為登入中，修改會員聯絡方式
  if (location.pathname === RouterSettings.MemberCenter.MemberMaintain &&
  location.state &&
  location.state.preUrl === RouterSettings.Login &&
  storageService.getItem(storageKeys.MemberId)) return true;

  let accessToken = '';
  if (storageService.getItem(storageKeys.LoginInfo)) {
    const loginInfo = JSON.parse(storageService.getItem(storageKeys.LoginInfo));
    accessToken = loginInfo.access_token;
  }
  // 需登入，且無 token 未通過
  if (needLogin && !accessToken) return false;

  return true;
};

export default renderRoutes;
